import { padding } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionEight = () => {
  const translations = useTranslations();

  return (
    <Section
      title={translations.patientForms.drvGeneralForm.sectionSeven.title}
    >
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          elementName="doctor_in_charge_in_hospital"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionSix.doctorName}
        />
        <TextInputWithLabel
          elementName="doctor_in_charge_in_hospital_first_name"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.doctorFirstName}
        />
        <TextInputWithLabel
          elementName="doctor_in_charge_in_hospital_phone"
          isBold
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorPhone
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="street_house_number_doctor"
          isBold
          isLarge
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorStreet
          }
        />
        <TextInputWithLabel
          elementName="postal_code_doctor"
          isBold
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorZipCode
          }
        />
        <TextInputWithLabel
          elementName="town_doctor"
          isBold
          isLarge
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorCity
          }
        />
      </SectionRow>
    </Section>
  );
};
